/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { InvoiceAutomationState } from '../state/InvoiceAutomationState'
import InvoiceAutomationEvent from '../../event/InvoiceAutomationEvent'

class InvoiceAutomationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new InvoiceAutomationState()
  }

  reduce(state, action) {
    const payload = action.payload
    switch (action.type) {
      case InvoiceAutomationEvent.fetchOne:
        return new InvoiceAutomationState(payload.invoice_automation)
      default:
        return state
    }
  }
}

export default new InvoiceAutomationStore()
